import { computed, getCurrentInstance, ref, watch } from 'vue';
import { useStateStore } from './useStateStore';
import type { ComponentState } from '../types/componentState';

export const useComponentContext = <TElement extends Record<string, any>>() => {
  const instance = getCurrentInstance();
  const parentElement = instance?.parent;

  const stateStore = useStateStore<TElement>();

  const parentId = computed((): number | null | undefined => {
    return stateStore.state[String(instance?.uid)]?.parent;
  });

  const componentState = computed(() => {
    return stateStore.state[String(instance?.uid)] as ComponentState<TElement> | undefined;
  });

  const parentState = computed(() => {
    return stateStore.state[String(parentId.value)] as ComponentState<TElement> | undefined;
  });

  const childrenStates = ref<ComponentState<unknown>[]>([]);

  watch(
    () => stateStore.state,
    () => {
      childrenStates.value = stateStore.findChildren(String(instance?.uid));
    },
    { deep: true }
  );

  return {
    uid: instance ? instance.uid : null,
    typeName: instance?.type.__name,
    parentUid: parentElement ? parentElement.uid : null,
    parentTypeName: parentElement?.type.__name || null,
    instance,
    componentState,
    parentState,
    childrenStates
  };
};
